import { createEvent, sample } from "effector"
import { or } from "patronum"
import { rxSample } from "rx-sample"
import { t } from "i18next"
import { notificationsApi } from "@callcenter/api"

import { KycChannel, selfServiceApi } from "../api"
import { $isVerifyModalVisible, kycStatusReceived } from "./kyc.model"
import { $isQrModalShown } from "./self-service.model"

sample({
  clock: selfServiceApi.startKycFx.fail,
  fn: () => ({ text: t("component_notification_notificationLabel_somethingWentWrongLabel") }),
  target: notificationsApi.failedNotificationFx
})

const kycChannel = new KycChannel()
const kycFlowOpened = createEvent()
const kycFlowClosed = createEvent()

const $isKycFlowOpen = or($isVerifyModalVisible, $isQrModalShown)

sample({ clock: $isKycFlowOpen, filter: (isOpen) => isOpen, target: kycFlowOpened })
sample({ clock: $isKycFlowOpen, filter: (isOpen) => !isOpen, target: kycFlowClosed })

rxSample({
  source: kycChannel.onUpdate,
  subscribeOn: kycFlowOpened,
  unsubscribeOn: kycFlowClosed,
  fn: ({ status }) => status,
  target: kycStatusReceived
})
